const styles = {
  main: {
    mt: 8,
    '&.confirmationPage': {
      mt: '0px!important',
    },
    '&.hideHeader': {
      mt: { xs: 2, lg: 4 },
    },
  },
  container: {
    '&.isScheduleStep': {
      height: '100%',
    },
  },
}

export default styles
